iScreenWizard.controller('OntwikkelwijzerController', function ($scope, $state, $mdDialog, Ajax, Dictionary, ErrorHandler, Opleidingsniveau, userService, Competentie, Ontwikkelwijzerblok, Ontwikkelwijzer) {

    $scope.opleidingsniveaus = [];
    $scope.ontwikkelwijzerblokken = [];
    $scope.competenties = [];
    $scope.user = userService.model;
    $scope.ontwikkelwijzer = {};
    $scope.readyForGenerate = false;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        refresh();
    });

    var refresh = function() {
        Opleidingsniveau.all().then(function (opleidingsniveaus) {
            $scope.opleidingsniveaus = opleidingsniveaus;
        });
        Ontwikkelwijzerblok.all().then(function (ontwikkelwijzerblokken) {
            $scope.ontwikkelwijzerblokken = ontwikkelwijzerblokken;
        });
    };

    $scope.selectOpleidingsniveau = function(opleidingsniveau) {
        $scope.comptenties = [];
        Competentie.all({'opleidingsniveau_id': opleidingsniveau.id, intellectuele_capaciteiten: 0}).then(function(competenties) {
            $scope.competenties = competenties;
        });
    };

    $scope.checkReadyForGenerate = function() {
        if ($scope.ontwikkelwijzer.opleidingsniveau &&
            $scope.ontwikkelwijzer.competenties && $scope.ontwikkelwijzer.competenties.length > 0 &&
            $scope.ontwikkelwijzer.ontwikkelwijzerblokken && $scope.ontwikkelwijzer.ontwikkelwijzerblokken.filter(function(blok) { return !blok.is_algemeen}).length > 0) {
            $scope.readyForGenerate = true;
        } else {
            $scope.readyForGenerate = false;
        }
    };

    $scope.downloadRapport = function(ev) {
        $mdDialog.show({
            controller: DownloadRapportDialogController,
            locals: {
                ontwikkelwijzer: $scope.ontwikkelwijzer,
            },
            templateUrl: '/info/ontwikkelwijzer/download-rapport',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true
        })
    };

    function DownloadRapportDialogController($scope, $mdDialog, ontwikkelwijzer) {
        $scope.ontwikkelwijzer = ontwikkelwijzer;
        $scope.stillLoading = true;
        $scope.downLoadUrl = '';

        Ontwikkelwijzer.downloadReport(ontwikkelwijzer).then(function (response) {
            $scope.stillLoading = false;
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                $scope.downLoadUrl = baseUrl + response.data.file_url + '?jwt=' + userService.getToken();
            }
        });
    }

});